import {Region} from "../Types";

export let CURRENT_REGION: Region | null = null;

export function setCurrentRegion(region: Region | null) {
  CURRENT_REGION = region;
}
